<template>
  <div>
    <list row-key="AppId" ref="list" unit="APP" :page="page" :query-params="params"
      :show-checkbox="$permission.canDel()" :show-query="false" :get-data-func="api.list">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <!-- <template slot="query">
        <el-form-item label="模拟器品牌">
          <el-select v-model="params.SimulatorBrand" clearable>
            <el-option v-for="item in brandList" :key="item.DataName" :value="item.DataName" />
          </el-select>
        </el-form-item>
      </template> -->
      <template slot="table">
        <!-- <el-table-column prop="DpName" label="归属机构" min-width="150" /> -->
        <el-table-column prop="VersionNo" label="版本号" />
        <el-table-column prop="Remark" label="备注" />
        <el-table-column prop="AddTime" label="创建时间" width="160" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
  import listMixin from "@/mixins/list";
  import list from "@/components/common/list";

  export default {
    mixins: [listMixin],
    components: { list },
    data() {
      return {
        api: require("@/api/op/app").default,
        params: {
          CoopMode: null,
          Status: null,
          DpIdChain: "",
        },
      };
    },
    methods: {
      delRange(ids) {
        this.api.delete({ ids }).then((res) => {
          if (res.Code == 0) {
            this.$message.success("删除成功");
            this.reload();
          } else {
            this.$message.error(res.Msg);
          }
        });
      },
    },
  };
</script>